// extracted by mini-css-extract-plugin
export var container = "About-module--container--5363a";
export var layout = "About-module--layout--358f1";
export var top = "About-module--top--6702c";
export var topText = "About-module--topText--7ac67";
export var textWrapper = "About-module--textWrapper--56df0";
export var text = "About-module--text--d67a4";
export var pictureTopWrapper = "About-module--pictureTopWrapper--7bc65";
export var pictureTop = "About-module--pictureTop--5acef";
export var img = "About-module--img--7a408";
export var quote = "About-module--quote--c4b53";
export var quoteText = "About-module--quoteText--2dc10";
export var author = "About-module--author--b6a93";
export var bottom = "About-module--bottom--01422";
export var pictureBottom = "About-module--pictureBottom--14c24";